// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { JsonValueSchema } from '../inputTypeSchemas/JsonValueSchema'

/////////////////////////////////////////
// TRACE MESSAGE SCHEMA
/////////////////////////////////////////

export const TraceMessageSchema = z.object({
  id: z.string(),
  tenantId: z.string().nullable(),
  traceId: z.string(),
  threadId: z.string(),
  message: JsonValueSchema,
  createdAt: z.coerce.date(),
})

export type TraceMessage = z.infer<typeof TraceMessageSchema>

export default TraceMessageSchema;
